import gql from "graphql-tag";

export const fragments = {
  fraudCommentsParts: gql`
    fragment FraudCommentsParts on Device {
      token
      suspicious_token_status
      suspicious_token_comments {
        comment
        status
        updated_at
        user
      }
      phone_number
      suspicious_phone_number_status
      suspicious_phone_number_comments {
        comment
        status
        updated_at
        user
      }
    }
  `,
};
